import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  contentContainerGrid: {
    width: "auto",
    margin: "auto",
    marginTop: -6,
    "& > div:last-of-type *:last-child": {
      marginBottom: 14,
    },
    "& > div:first-of-type": {
      margin: 0,
    },

    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      maxWidth: "90rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
      maxWidth: "53.75rem",
    },
  },
  title: {
    fontFamily: "var(--font-family-1)",
    fontWeight: 500,
    fontSize: 18,
    lineHeight: "28px",
    textAlign: "left",
    color: "#677aa7",
    marginBottom: 26,
  },
  subtitle: {
    fontFamily: "var(--font-family-1)",
    fontWeight: "bold",
    fontSize: 12,
    textAlign: "left",
    color: "#a6b5d9",
    "p,span,strong": {
      color: "#c0cce7ff",
      margin: 0,
      padding: 0,
    },
  },
  underline: {
    fontFamily: "var(--font-family-1)",
    textDecoration: "underline",
    cursor: "pointer",
    marginBottom: 0,
    marginTop: 30,
    lineHeight: 1.6,
  },
  end: {
    color: "#a6b5d9",
    fontWeight: "bold",
    fontSize: 12,
  },
  policy: {
    fontFamily: "var(--font-family-3)",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: 1.6,
    textAlign: "justify",
    color: "#a6b5d9",
    "p,span,strong": {
      color: "#a6b5d9",
      margin: 0,
      padding: 0,
    },

    "& h4": {
      fontWeight: 700,
      color: "#c0cce7ff",
      margin: "22px 0 10px",
    },

    "& a": {
      textDecoration: "underline",
      cursor: "pointer",
      marginBottom: 0,
      marginTop: 30,
      lineHeight: 1.6,
      color: "#954f72",
    },

    "& ul": {
      paddingLeft: "16px;",
      display: "flex",
      flexDirection: "column",
      gap: "14px",
    },
  },
}));

export default useStyles;
